import type { ComponentProps } from 'react'

import { FormItem, MultipleChoice } from '@monthio/design-system'
import { useField } from 'formik'
import { useTranslation } from 'react-i18next'

type FormikSingleSelectProps = Omit<
	ComponentProps<typeof MultipleChoice>,
	'onChange' | 'requiredText'
> & {
	fieldName: string
	label: string
	errorText?: string
	hintText?: string
	isRequired?: boolean
} & {
	additionalOnChange?: (value: string | undefined) => void
	onChange?: (value: string | undefined) => void
	selected?: string | undefined
	defaultValue?: string
}

export const FormikSingleSelect = ({
	fieldName,
	label,
	hintText,
	isRequired,
	onBlur,
	additionalOnChange,
	onChange,
	selected,
	errorText,
	...props
}: FormikSingleSelectProps) => {
	const { t } = useTranslation()
	const [field, meta, { setValue, setTouched }] = useField<string | undefined>(
		fieldName,
	)

	return (
		<FormItem
			label={label}
			isRequired={isRequired}
			requiredText={t('required')}
			errorText={
				meta.touched && !!meta.error ? (errorText ?? meta.error) : undefined
			}
			hintText={hintText}
		>
			<MultipleChoice
				{...props}
				fieldName={fieldName}
				type="radio"
				selected={selected ?? field.value}
				onChange={
					onChange ??
					((value) => {
						additionalOnChange?.(value)
						setValue(value)
					})
				}
				onBlur={(e) => {
					onBlur?.(e)
					setTouched(true)
				}}
				isRequired={false}
			/>
		</FormItem>
	)
}
